export { default as GeneralImg } from './components/general-img';
const bizCssPrefix = 'bizpack';
export { bizCssPrefix };
